export const actionTypes = {
    SET_ACTIVE_TAB: 'advancedAnalyticsV2/SET_ACTIVE_TAB',
    CLEAR_STORE: 'advancedAnalyticsV2/CLEAR_STORE',
    GET_ANNUAL_MAINTENANCE_PLAN: 'advancedAnalyticsV2/GET_ANNUAL_MAINTENANCE_PLAN',
    GET_DAILY_AGING_STRESS: 'advancedAnalyticsV2/GET_DAILY_AGING_STRESS',
    SET_DATE_SELECTION: 'advancedAnalyticsV2/SET_DATE_SELECTION',
    GET_LUBRICATION_RECOMMENDATION_DATA: 'advancedAnalyticsV2/GET_LUBRICATION_RECOMMENDATION_DATA',
    GET_LUBRICATION_MAINTENANCE_INFO: 'advancedAnalyticsV2/GET_LUBRICATION_MAINTENANCE_INFO',
    UPDATE_CURRENT_LUBRICATION_MAINTENANCE_INFO: 'advancedAnalyticsV2/UPDATE_CURRENT_LUBRICATION_MAINTENANCE_INFO',
    UPDATE_LUBRICATION_MAINTENANCE_INFO: 'advancedAnalyticsV2/UPDATE_LUBRICATION_MAINTENANCE_INFO',
};

export const advancedAnalyticsButtons = {
    annualMaintenancePlan: 'AnnualMaintenancePlan',
    dailyAgingStress: 'DailyAgingStress'
};

export const gaugeCategories = {
    pmKit: 'PMKit',
    deionizer: 'Deionizer'
};

export const gaugeTypes = {
    STATIC_PMKIT: 'StaticPMKit',
    CONDITION_BASED_PMKIT: 'ConditionBasedPMKit',
    STATIC_DEIONIZER: 'StaticDeionizer',
    CONDITION_BASED_DEIONIZER: 'ConditionBasedDeionizer'
};

export const tabContainerIds = {
    [advancedAnalyticsButtons.annualMaintenancePlan]: 'annual-maintenance-plan',
    [advancedAnalyticsButtons.dailyAgingStress]: 'daily-aging-stress'
};

export const ProductTypes = {
    ACS6080: 'acs6080',
};

export const emptyMaintenanceValue = '-';

export const rowIds = {
    maintenanceStatus: 'maintenance-status',
    nextPMKitMaintenance: 'pm-kit-maintenance',
    nextConditionBasedMaintenance: 'next-condition-based-maintenance',
    lifecycleStatus: 'lifecycle-status',
    overdueMaintenance: 'overdue-maintenance',
    executedMaintenance: 'executed-maintenance'
};

export const chartTypes = {
    environment: 'Environment',
    cyclic: 'Cyclic'
};

export const noDataJson = {
    assetId: null,
    serialNumber: null,
    driveName: null,
    commissioningDate: null,
    cbmActivationDate: null,
    startDate: null,
    lifecycleStatus: '',
    maintenanceStatus: null,
    maintenanceKits: [],
    staticMaintenanceKits: [],
    remainingLifetimeTrend: [],
    remainingIgbtLifetimeTrend: [],
    staticMaintenancePlan: null,
    thresholdOverdue: null,
    thresholdPlanning: null,
    dueInYears: null,
    dueInMonths: null,
    due: false,
    overDueInYears: null,
    overDueInMonths: null,
    overDue: true,
    maintenanceAdvice: null,
    maintenancePriority: null
};
